import { render, staticRenderFns } from "./image-field.vue?vue&type=template&id=2a258ad7&scoped=true&"
import script from "./image-field.vue?vue&type=script&lang=js&"
export * from "./image-field.vue?vue&type=script&lang=js&"
import style0 from "./image-field.vue?vue&type=style&index=0&id=2a258ad7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a258ad7",
  null
  
)

export default component.exports